module.exports = __webpack_public_path__ + "img/button2.11dfa53e.png";